/**
 * Resolves once the given IndexedDB request succeeds, with the request's own result.
 *
 * Rejects with the request's own `error`, or with `fallbackErrorMessage` when the browser gives
 * none — the caller supplies that message so the rejection can still name the subsystem that
 * issued the request.
 */
const waitForIndexedDbRequest = <Result>(
	request: IDBRequest<Result>,
	fallbackErrorMessage: string,
): Promise<Result> => {
	return new Promise((resolve, reject) => {
		request.onsuccess = () => {
			resolve(request.result);
		};
		request.onerror = () => {
			reject(request.error ?? new Error(fallbackErrorMessage));
		};
	});
};

export default waitForIndexedDbRequest;
